var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 90,
    viewBox: "0 0 79 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0669 77.5805L12.5604 82.7246L54.8541 85.3715L55.8284 88.9328L58.3146 89L58.4154 81.8102L59.7928 80.7015L64.698 82.4822L67.4193 82.8518L66.1091 80.4328L67.5201 78.5177L65.7731 77.6442L67.1842 76.8379L66.3442 74.6205H67.6209L67.5537 70.7904L70.2079 71.3952L71.6862 68.2707H69.4352L68.7296 67.0612L71.6526 66.5572L72.3917 65.5157L69.3344 64.6086L72.6269 64.0374L73.7692 62.6936L72.6269 60.4426L74.6091 61.4841L75.617 60.7449L74.4411 59.4011L76.3898 59.6362L77.9868 57.8672L73.5439 57.2669L71.8629 50.4225L68.6208 46.9403L66.9397 39.6156L61.8965 34.9327L59.8552 32.7713L60.6958 31.2103L56.2529 27.8482L55.0522 24.7262L49.6487 21.0038L45.2404 11.4779L42.6782 11.1775L37.4235 7.41625L37.1469 5.56327L40.6869 2.52107L41.0188 1L1 1.22127L8.24597 43.3973L11.3711 50.6709L10.8733 52.8834L12.5051 53.9067L9.98832 56.2575L8.4672 62.7844L10.2925 67.0711L9.26925 73.598L11.0669 77.5805Z",
    fill: "#273137",
    fillOpacity: 0.1,
    stroke: "#273137",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGa);
export default __webpack_public_path__ + "static/media/GA.0bf2af9aa2497339dff928a746ccbc6b.svg";
export { ForwardRef as ReactComponent };